import { ElMessage, ElMessageBox } from "element-plus";
import { reactive, ref } from "vue";
import { queryTableOut, batchDeleteByIds, queryBoundTotal } from "@/api/bound";
import { postDownload } from "@/utils";

export default function useOutStorageTable() {
  // 表单搜索ref
  const searchRef = ref(null);

  // 表格ref
  const tableRef = ref(null);

  // 新增编辑的ref
  const editRef = ref(null);

  // 搜索表单
  const searchData = reactive({
    number: null,
    type: null,
    warehouseId: null,
    materialNameText: null,
    thirdResourceName: null,
    remark: null,
    processStatus: null,
    startTime: null,
    endTime: null,
    boundType: "OUT",
    outType: null,
  });

  // 表格列配置
  const columns = ref([
    {
      label: "出库单号",
      prop: "number",
    },
    {
      label: "出库类型",
      prop: "typeText",
    },
    // {
    //   label: "申请单号",
    //   prop: "number",
    // },

    {
      label: "出库仓库",
      prop: "warehouseName",
    },
    {
      label: "出库时间",
      prop: "boundTime",
    },
    {
      label: "物料名称",
      prop: "materialNameText",
    },
  ]);

  // 出库数据
  const outBoundTotal = ref({
    changeQuantity: 0,
    count: 0,
  });

  // 表格数据
  const tableData = ref([]);

  // 表格遮罩
  const tableLoading = ref(false);

  // 分页数据
  const pages = reactive({
    page: 1,
    size: 10,
    total: 0,
  });
  const handleSizeChange = (val) => {
    pages.size = val;
    pages.page = 1;
    getList();
  };
  const handleCurrentChange = (val) => {
    pages.page = val;
    getList();
  };
  // 日期范围选择器
  const datePicker = ref("");

  // 多选表格的ids
  const deleteIds = ref([]);

  // 点击重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    datePickerChange(null);
    datePicker.value = "";
    pages.page = 1;
    getList();
  };

  // 获取表格数据
  const getList = () => {
    tableLoading.value = true;
    queryTableOut({
      ...searchData,
      page: pages.page,
      limit: pages.size,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
        outBoundTotal.value.count = res.data.total;
        queryBoundTotal({
          ...searchData,
        }).then((res2) => {
          outBoundTotal.value.changeQuantity = res2.data.changeQuantity || 0;
        });
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 点击新增或编辑
  const handleAdjust = (row, type) => {
    editRef.value?.handleDialogOpen({ row, type });
  };

  // 时间范围选择器变化
  const datePickerChange = (val) => {
    searchData.startTime = val?.[0] ?? null;
    searchData.endTime = val?.[1] ?? null;
  };

  const handleSelectionChange = (val) => {
    deleteIds.value = [];
    val.forEach((item) => {
      deleteIds.value.push(item.id);
    });
  };

  const handleBatchDelete = (id, type) => {
    if (type) {
      if (deleteIds.value.length == 0)
        return ElMessage.warning("未选择任何数据");
      handleDelete(deleteIds.value.join(","));
    } else {
      handleDelete([id].join(","));
    }
  };

  // 批量删除
  const handleDelete = (ids) => {
    ElMessageBox.confirm("确定删除所选数据吗?", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        batchDeleteByIds(ids).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {
        ElMessage.info("已取消");
      })
      .finally(() => {
        deleteIds.value = [];
        tableRef.value?.clearSelection();
      });
  };

  // 导出
  const handleExport = () => {
    ElMessageBox.confirm("确定导出出库数据吗?", "导出", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        postDownload("/bound/exportByOut", {}, "出库记录.xlsx");
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  return {
    searchRef,
    searchData,
    columns,
    outBoundTotal,
    tableData,
    tableLoading,
    pages,
    handleSizeChange,
    handleCurrentChange,
    editRef,
    datePicker,
    tableRef,
    handleReset,
    getList,
    handleAdjust,
    handleExport,
    datePickerChange,
    handleSelectionChange,
    handleBatchDelete,
  };
}
